import axios from 'axios';
import { getApiUrl } from '../../endpoints';

export const login = async (credentials) => {
  const response = await axios.post(`${getApiUrl()}/auth/login`, credentials, { headers: { "Content-Type": "application/json" } })
  return response.data
}